import { render } from "./CheckUpFaq_reserve.vue?vue&type=template&id=0cd85c81"
import script from "./CheckUpFaq_reserve.vue?vue&type=script&lang=js"
export * from "./CheckUpFaq_reserve.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__